export const COORDS_DECIMAL = 6;
